export interface CardRadioOption<T extends string = string> {
  value: T;
  primary: string;
  helper?: string;
}

export interface CardRadioGroupProps<T extends string = string> {
  options: CardRadioOption<T>[];
  selected: T | null;
  onChange: (value: T) => void;
  name: string;
}

/** Primitive 8: Card Radio (replaces dropdown for ≤4 options). */
export function CardRadioGroup<T extends string = string>({
  options,
  selected,
  onChange,
  name,
}: CardRadioGroupProps<T>): JSX.Element {
  return (
    <div
      role="radiogroup"
      aria-label={name}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 'var(--sp-6)',
      }}
    >
      {options.map((opt) => {
        const isSelected = selected === opt.value;
        return (
          <label
            key={opt.value}
            className={`card-radio ${isSelected ? 'is-selected' : ''}`}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={isSelected}
              onChange={() => onChange(opt.value)}
              style={{ width: 16, height: 16, accentColor: 'var(--pcb-blue)' }}
            />
            <div className="card-radio__body">
              <span className="card-radio__primary">{opt.primary}</span>
              {opt.helper && <span className="card-radio__helper">{opt.helper}</span>}
            </div>
          </label>
        );
      })}
    </div>
  );
}
